<span [formGroup]="form">
  <mat-checkbox [formControl]="formControl">
    {{ label }}
  </mat-checkbox>
  <app-boomer-forms-errors [control]="formControl"></app-boomer-forms-errors>
</span>
